var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboardPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26309"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18293",
    d: "M13.333 4.556h1.556a1.556 1.556 0 0 1 1.556 1.556v9.333A1.556 1.556 0 0 1 14.889 17H7.111a1.556 1.556 0 0 1-1.556-1.556v-.778m7.778-10.11a1.556 1.556 0 0 1-1.556 1.556h-1.555a1.556 1.556 0 0 1-1.555-1.556m4.667 0A1.556 1.556 0 0 0 11.778 3h-1.556a1.556 1.556 0 0 0-1.555 1.556m0 0H7.111a1.556 1.556 0 0 0-1.555 1.555v2.333M4 11.556h7.778m0 0L9.444 9.222m2.333 2.333-2.333 2.334",
    transform: "translate(-1 -1)",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardPending);
export default __webpack_public_path__ + "static/media/clipboard-pending.38df6bbc223364b51051284888c0b515.svg";
export { ForwardRef as ReactComponent };